// Motorcycle & ATV catalog for the custom build form dropdowns.
// Curated common models. "Other" fallbacks allow write-in when we don't have the brand.

export const MOTO_BRANDS = {
  "Harley-Davidson": {
    models: [
      "Sportster (all)", "Iron 883", "Iron 1200", "Forty-Eight", "Nightster",
      "Softail Standard", "Street Bob", "Fat Bob", "Fat Boy", "Heritage Classic",
      "Low Rider", "Low Rider S", "Low Rider ST",
      "Road King", "Road Glide", "Street Glide", "Electra Glide",
      "Sport Glide", "Pan America", "LiveWire",
      "Other Harley",
    ],
  },
  "BMW Motorrad": {
    models: [
      "R nineT", "R 1200 GS", "R 1250 GS", "R 1250 GS Adventure",
      "R 1250 RT", "S 1000 RR", "S 1000 R", "S 1000 XR",
      "F 850 GS", "F 900 R", "F 900 XR", "K 1600", "M 1000 RR",
      "Other BMW Motorrad",
    ],
  },
  Ducati: {
    models: [
      "Panigale V2", "Panigale V4", "Streetfighter V2", "Streetfighter V4",
      "Monster", "Monster SP", "Multistrada V2", "Multistrada V4",
      "Scrambler", "Diavel V4", "Hypermotard", "SuperSport 950",
      "Other Ducati",
    ],
  },
  Honda: {
    models: [
      "CBR600RR", "CBR650R", "CBR1000RR-R Fireblade",
      "CB300R", "CB500F", "CB650R", "CB1000R",
      "Africa Twin CRF1100L", "NC750X", "Rebel 300", "Rebel 500", "Rebel 1100",
      "Gold Wing", "Grom", "Monkey", "Fury",
      "TRX250X ATV", "TRX400X ATV", "TRX700XX ATV", "TRX90X ATV",
      "Other Honda",
    ],
  },
  Yamaha: {
    models: [
      "YZF-R1", "YZF-R6", "YZF-R7", "YZF-R3",
      "MT-03", "MT-07", "MT-09", "MT-10",
      "Ténéré 700", "Super Ténéré", "Tracer 9 GT", "XSR700", "XSR900",
      "Bolt", "V-Star", "V-Max", "FJR1300",
      "YFZ450R ATV", "Raptor 700R ATV", "Grizzly 700 ATV", "Kodiak 700 ATV",
      "Other Yamaha",
    ],
  },
  Kawasaki: {
    models: [
      "Ninja 400", "Ninja 650", "Ninja ZX-6R", "Ninja ZX-10R", "Ninja ZX-14R", "Ninja H2",
      "Z400", "Z650", "Z900", "Z900RS", "Z H2",
      "Versys 650", "Versys 1000", "Vulcan S", "Vulcan 900", "Vulcan 1700",
      "KLR650", "KX250", "KX450",
      "Brute Force 750 ATV", "Brute Force 300 ATV", "KFX90 ATV",
      "Other Kawasaki",
    ],
  },
  Suzuki: {
    models: [
      "GSX-R600", "GSX-R750", "GSX-R1000", "GSX-S750", "GSX-S1000", "Hayabusa",
      "SV650", "V-Strom 650", "V-Strom 1050", "Boulevard M109R", "Boulevard C90",
      "DR650S", "DR-Z400S",
      "KingQuad 750 ATV", "KingQuad 500 ATV", "LT-Z400 ATV",
      "Other Suzuki",
    ],
  },
  Triumph: {
    models: [
      "Bonneville T100", "Bonneville T120", "Speed Twin", "Thruxton RS",
      "Street Twin", "Street Triple", "Speed Triple 1200 RS",
      "Tiger 900", "Tiger 1200", "Rocket 3", "Scrambler 900", "Scrambler 1200",
      "Other Triumph",
    ],
  },
  KTM: {
    models: [
      "RC 390", "RC 390 GP", "890 Duke R", "1290 Super Duke R", "790 Duke",
      "390 Adventure", "890 Adventure", "1290 Super Adventure",
      "300 XC-W", "450 SX-F", "500 EXC-F",
      "Other KTM",
    ],
  },
  "Indian Motorcycle": {
    models: [
      "Scout", "Scout Bobber", "Scout Rogue", "Scout Sixty",
      "Chief", "Chief Bobber", "Chief Dark Horse", "Chief Vintage",
      "Springfield", "Roadmaster", "Challenger", "Pursuit", "FTR",
      "Other Indian",
    ],
  },
  Aprilia: {
    models: ["RS 660", "RSV4", "Tuono V4", "Tuareg 660", "Other Aprilia"],
  },
  Husqvarna: {
    models: ["Svartpilen 401", "Svartpilen 701", "Vitpilen 401", "Norden 901", "FE 501", "TE 300", "Other Husqvarna"],
  },
  Polaris: {
    models: [
      "Sportsman 570 ATV", "Sportsman 850 ATV", "Sportsman 1000 XP ATV",
      "Scrambler XP 1000 ATV", "Outlaw 110 EFI ATV",
      "RZR XP 1000", "RZR Turbo R", "RZR Pro R",
      "Ranger 1000", "Ranger XP 1000", "General 1000",
      "Other Polaris",
    ],
  },
  "Can-Am": {
    models: [
      "Ryker 600", "Ryker 900", "Spyder F3", "Spyder RT",
      "Outlander 570 ATV", "Outlander 850 ATV", "Outlander X mr 1000R ATV",
      "Renegade 570 ATV", "Renegade 1000R ATV",
      "Maverick X3", "Maverick Sport", "Defender HD10",
      "Other Can-Am",
    ],
  },
  "Arctic Cat": {
    models: [
      "Alterra 300 ATV", "Alterra 570 ATV", "Alterra 700 ATV", "Alterra 1000 XT ATV",
      "Wildcat XX", "Wildcat Trail", "Prowler Pro",
      "Other Arctic Cat",
    ],
  },
  "Other (write-in)": { models: ["Other / unknown"] },
};

export const MOTO_MAKES = Object.keys(MOTO_BRANDS);

export const VEHICLE_KIND = [
  { value: "motorcycle", label: "Motorcycle" },
  { value: "atv", label: "ATV / UTV" },
];

export const MOTO_BUILD_TYPES = [
  "Full custom build",
  "Café racer conversion",
  "Bobber / chopper conversion",
  "Scrambler / tracker conversion",
  "Performance / engine build",
  "Suspension & handling",
  "Exhaust + intake + tune",
  "Paint / bodywork",
  "Wheels & tires",
  "Electrical / wiring / lighting",
  "Rebuild / restoration",
  "One-off idea (describe below)",
];

export const MOTO_YEARS = (() => {
  const max = new Date().getFullYear() + 1;
  const arr = [];
  for (let y = max; y >= 1970; y--) arr.push(String(y));
  return arr;
})();

// Verified motorcycle gallery photos (Unsplash, content-checked)
export const MOTO_GALLERY = [
  {
    url: "https://images.unsplash.com/photo-1568772585407-9361f9bf3a87?w=1400&q=85",
    alt: "Ducati SuperSport in low light",
    tag: "Ducati SuperSport",
    size: "lg",
  },
  {
    url: "https://images.unsplash.com/photo-1531327431456-837da4b1d562?w=1400&q=85",
    alt: "Custom BMW K-series café racer at golden hour",
    tag: "BMW café racer",
    size: "md",
  },
  {
    url: "https://images.unsplash.com/photo-1558981285-6f0c94958bb6?w=1400&q=85",
    alt: "Blacked-out custom Harley bobber build",
    tag: "Custom Harley bobber",
    size: "md",
  },
  {
    url: "https://images.unsplash.com/photo-1558981806-ec527fa84c39?w=1400&q=85",
    alt: "Harley-Davidson Softail on the open road",
    tag: "Harley Softail",
    size: "md",
  },
  {
    url: "https://images.unsplash.com/photo-1449426468159-d96dbf08f19f?w=1400&q=85",
    alt: "KTM RC sportbike",
    tag: "KTM RC",
    size: "md",
  },
  {
    url: "https://images.unsplash.com/photo-1591637333184-19aa84b3e01f?w=1400&q=85",
    alt: "KTM 890 Duke R streetfighter",
    tag: "KTM 890 Duke R",
    size: "md",
  },
  {
    url: "https://images.unsplash.com/photo-1580310614729-ccd69652491d?w=1400&q=85",
    alt: "Kawasaki Ninja ZX-6R with custom livery",
    tag: "Kawasaki Ninja ZX-6R",
    size: "lg",
  },
];
